import { render } from "./PayrollStatusList.vue?vue&type=template&id=7c5c61b7"
import script from "./PayrollStatusList.vue?vue&type=script&lang=js"
export * from "./PayrollStatusList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__